import { render, staticRenderFns } from "./CollectivesList.vue?vue&type=template&id=1e0d3a3f&scoped=true&"
import script from "./CollectivesList.vue?vue&type=script&lang=js&"
export * from "./CollectivesList.vue?vue&type=script&lang=js&"
import style0 from "./CollectivesList.vue?vue&type=style&index=0&id=1e0d3a3f&lang=scss&scoped=true&"
import style1 from "./CollectivesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0d3a3f",
  null
  
)

export default component.exports